// Site-wide SEO config. Update SITE_URL when you point a custom domain.

export const SITE_URL = "https://toftgasheatingandplumbing.co.uk";
export const SITE_NAME = "TOFT Gas, Heating & Plumbing";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

export const PAGE_SEO = {
  home: {
    path: "/",
    title:
      "Gas Engineer Cardiff, Pontypridd, Porth, Bridgend & Caerphilly | TOFT Gas, Heating & Plumbing",
    description:
      "Gas Safe registered boiler servicing from £70, CP12 certificates from £70, boiler repairs and heating services across Cardiff, Pontypridd, Porth, Bridgend, Caerphilly and Rhondda Cynon Taf. Call, WhatsApp or text Lee today.",
    keywords:
      "gas engineer cardiff, boiler service pontypridd, boiler repair bridgend, CP12 certificate cardiff, gas safe engineer porth, plumber treorchy, gas engineer caerphilly, boiler service rhondda cynon taf, landlord gas safety certificate cardiff, gas engineer tonypandy, plumber llantrisant, boiler installation porthcawl",
  },
  boiler: {
    path: "/boiler-services",
    title:
      "Boiler Servicing Cardiff, Pontypridd, Bridgend & Caerphilly | From £70 | TOFT",
    description:
      "Boiler servicing from £70, repairs and free new boiler quotes across Cardiff, Pontypridd, Porth, Bridgend, Caerphilly and Rhondda Cynon Taf. Gas Safe registered engineer.",
    keywords:
      "boiler service cardiff, boiler service pontypridd, boiler repair bridgend, boiler repair caerphilly, boiler installation cardiff, combi boiler service rhondda, gas safe boiler engineer porth, boiler service tonypandy",
  },
  landlord: {
    path: "/landlord-services",
    title:
      "Landlord Gas Safety Certificates (CP12) Cardiff & RCT | From £70 | TOFT",
    description:
      "Fast CP12 landlord gas safety certificates from £70 across Cardiff, Rhondda Cynon Taf, Bridgend and Caerphilly. Trusted by landlords, HMO owners and property investors.",
    keywords:
      "CP12 certificate cardiff, landlord gas safety certificate cardiff, CP12 pontypridd, CP12 bridgend, HMO gas safety inspection cardiff, landlord gas certificate caerphilly, landlord gas safety rhondda cynon taf, property investor gas certificate",
  },
  gasHeating: {
    path: "/gas-heating",
    title:
      "Gas & Heating Engineer Cardiff, Pontypridd, Bridgend & Caerphilly | TOFT",
    description:
      "Gas Safe heating engineer covering Cardiff, Pontypridd, Porth, Bridgend, Caerphilly and Rhondda Cynon Taf — thermostats, radiators, gas hobs, system flushing and emergency callouts.",
    keywords:
      "gas engineer cardiff, heating engineer pontypridd, thermostat installation cardiff, smart thermostat rhondda, radiator replacement bridgend, system flush caerphilly, gas hob installation cardiff",
  },
  plumbing: {
    path: "/plumbing-services",
    title:
      "Plumber Cardiff, Pontypridd, Porth, Bridgend & Caerphilly | TOFT",
    description:
      "Trusted plumber covering Cardiff, Pontypridd, Porth, Bridgend, Caerphilly and Rhondda Cynon Taf. Leaks, bathrooms, rental property maintenance — Gas Safe registered.",
    keywords:
      "plumber cardiff, plumber pontypridd, plumber bridgend, plumber caerphilly, plumber porth, bathroom installation cardiff, leak repair rhondda, plumber treorchy",
  },
  areas: {
    path: "/areas-covered",
    title:
      "Gas Engineer Cardiff, Porth, Pontypridd, Bridgend & Caerphilly | TOFT",
    description:
      "Boiler servicing, CP12 certificates and plumbing across Cardiff, Pontypridd, Porth, Treorchy, Tonypandy, Llantrisant, Talbot Green, Bridgend, Porthcawl and Caerphilly.",
    keywords:
      "gas engineer porth, plumber pontypridd, boiler service tonypandy, gas engineer treorchy, plumber llantrisant, gas engineer porthcawl, boiler repair cardiff, plumber talbot green",
  },
  reviews: {
    path: "/reviews",
    title: "Customer Reviews — Gas Engineer Cardiff & South Wales | TOFT",
    description:
      "5.0★ rated Gas Safe engineer covering Cardiff, Pontypridd, Porth, Bridgend and Caerphilly. Read what landlords, homeowners and HMO owners say about TOFT's boiler servicing, CP12 certificates and heating work.",
    keywords:
      "TOFT plumbing reviews, gas engineer reviews cardiff, boiler service reviews pontypridd, landlord gas engineer reviews bridgend, plumber reviews porth",
  },
  faq: {
    path: "/faq",
    title:
      "Boiler Servicing & CP12 FAQs — Cardiff, Pontypridd, Bridgend | TOFT",
    description:
      "Answers about boiler servicing, CP12 certificates, landlord gas safety, smart thermostats, emergency callouts and our service areas in Cardiff, Pontypridd, Bridgend and Caerphilly.",
    keywords:
      "boiler service faq cardiff, CP12 certificate faq, landlord gas safety questions, gas engineer south wales faq",
  },
  contact: {
    path: "/contact",
    title:
      "Contact TOFT — Gas Engineer Cardiff, Pontypridd & Bridgend | WhatsApp, Call or Text",
    description:
      "Get in touch with Lee — Gas Safe registered engineer in Porth. WhatsApp, call 07885 592820 or text. Serving Cardiff, Pontypridd, Bridgend, Caerphilly and Rhondda Cynon Taf.",
    keywords:
      "contact gas engineer cardiff, whatsapp plumber pontypridd, call boiler engineer bridgend, TOFT plumbing contact porth",
  },
};
